import i18next from "i18next";
import * as yup from "yup";

export function validation() {
  return yup.object().shape({
    name: yup
      .string()
      .required(i18next.t("validation.createMemories.name"))
      .min(3, "Minimum 3 Character required")
      .trim(i18next.t("validation.common.noSpace")),
    email: yup
      .string()
      .required(i18next.t("validation.adminAuth.email"))
      .email(i18next.t("validation.adminAuth.validEmail")),
  });
}
